import React from "react";
import DataGrid from '../../Components/DataGridView/DataGridView';
import ScrollTop from '../ScrollButton';
import Card from "../../Components/Card";
import SiteMap from "../../Components/SiteMap";
import ProgressSpinner from "../../Components/ProgressSpinner";
import Util from "../../Util";
import Input from '../../Components/Input';
import SearchEmployees from '../Employees/SearchEmployees';
import Dropdown from "../../Components/Dropdown";
import Calendar from "../../Components/Calendar";
import Checkbox from '../../Components/Checkbox';
import ButtonsBarLookupList from '../../Components/ButtonsBarLookupList';
import http from '../../Api/http';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Messages from "../../Components/Messages";
import Print from "../../Print";
import Button from "../../Components/Button";
import AdditionalFilters from "../AdditionalFilters/AdditionalFilters";

const $ = window.$;

export default class salariesPerHours extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDesktop: window.innerWidth > 1250,
            transTypeList: this.transTypeList,
            fromCode: !Util.checkISHR() ? localStorage.getItem("useridHR") : '',
            toCode: !Util.checkISHR() ? localStorage.getItem("useridHR") : '',
            fromDate: new Date(),
            toDate: new Date(),
            fromMinute: 0,
            toMinute: 32000,
            observeRestPeriod: false,
            showTotalInHours: true,
            shift: undefined,
            section: undefined,
            branch: undefined,
            department: undefined,
            filterShown: true,
            data: [],
            dataObject:
            {
                additionalFiltersObj: undefined
            }

        };
    }

    componentDidMount = async () => {
        if (Util.checkISHR()) {
            if (!$.license.Att_Module) {
                Util.goTo('/License');
                return;
            }
            if (!Util.checkRights(529)) {
                Util.goTo('/Access');
                return;
            }
        }
        else {
            if (!$.license.SelfService_Module) {
                Util.goTo('/License');
                return;
            }
            if (!Util.checkRights(774)) {
                Util.goTo('/Access');
                return;
            }
        }

        let _isDesktop = this.updatePredicate();

        let shiftsPromise = this.getShifts();
        let branchesPromise = this.getBranches();
        let sectionsPromise = this.getSections();
        let departmentsPromise = this.getDepartments();

        let shiftsList = await shiftsPromise;
        let branchesList = await branchesPromise;
        let sectionsList = await sectionsPromise;
        let departmentsList = await departmentsPromise;

        this.setState({
            shiftsList: shiftsList, branchesList: branchesList, sectionsList: sectionsList, departmentsList: departmentsList,
            shift: shiftsList && shiftsList.length > 0 ? shiftsList[0] : undefined,
            section: sectionsList && sectionsList.length > 0 ? sectionsList[0] : undefined,
            branch: branchesList && branchesList.length > 0 ? branchesList[0] : undefined,
            department: departmentsList && departmentsList.length > 0 ? departmentsList[0] : undefined,
            isDesktop: _isDesktop, loading: false
        })

    }
    updatePredicate = () => {
        return window.innerWidth > 1250
    }
    handleUserInput = (e) => {
        const name = e.target.id;
        const value = e.target.value;

        this.setState({ [name]: value });
    }

    render = () => {
        const gridStyle = { minHeight: this.state.filterShown ? '42vh' : '55vh' }
        let siteMapItems = [
            { label: $.strings.links.reports.menu },
            { label: $.strings.salariesPerHours.title }
        ];
        const siteMapHome = { icon: 'pi pi-home', url: "/" }

        return <div ref="divMain" >
            <SearchEmployees ref={e => this.dlgSearchFromEmployee = e} onSuccess={this.showFromEmp} />
            <SearchEmployees ref={e => this.dlgSearchToEmployee = e} onSuccess={this.showToEmp} />
            <ProgressSpinner loading={this.state.loading} />
            <Card>
                <SiteMap model={siteMapItems} home={siteMapHome} />
                <ButtonsBarLookupList onRefresh={this.getData} onExcelExport={this.excelExport} onPrint={this.print} />
                <Messages innerRef={(el) => this.messages = el} />
                <AdditionalFilters ref={e => this.dlgAdditionalFilters = e} onSuccess={this.onAdditionalFiltersSuccess} />
            </Card>

            <Accordion multiple activeIndex={[0, 1]} >
                <AccordionTab header={$.strings.filterCaption}>

                     <div className="p-grid">
                     <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Dropdown
                                id="fromSection"
                                value={this.state.fromSection}
                                options={this.state.sectionsList}
                                caption={$.strings.generalHolidayRpt.fromSection}
                                onChange={this.handleUserInput}
                                optionLabel="Name"
                            />
                        </div>
                        <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Dropdown
                                id="toSection"
                                value={this.state.toSection}
                                options={this.state.sectionsList}
                                caption={$.strings.generalHolidayRpt.toSection}
                                onChange={this.handleUserInput}
                                optionLabel="Name"
                            />
                        </div>
                         </div>

                    <div className="p-grid">
                        <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtFromCode = el}
                                type="text"
                                id="fromCode"
                                value={this.state.fromCode}
                                autofocus={true}
                                autocomplete="off"
                                onChange={this.handleUserInput}
                                caption={$.strings.inOutTotalReport.fromCode}
                                withgroup={Util.checkISHR() || Util.checkISManager()}
                                btn1icon="search"
                                btn1event={this.getFromCode}
                                disabled={!Util.checkISHR() && !Util.checkISManager()}
                            />
                        </div>
                        <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Input
                                innerRef={(el) => this.txtToCode = el}
                                type="text"
                                id="toCode"
                                value={this.state.toCode}
                                autofocus={true}
                                autocomplete="off"
                                onChange={this.handleUserInput}
                                caption={$.strings.inOutTotalReport.toCode}
                                withgroup={Util.checkISHR() || Util.checkISManager()}
                                btn1icon="search"
                                btn1event={this.getToCode}
                                disabled={!Util.checkISHR() && !Util.checkISManager()}
                            />
                        </div>

                        <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Calendar
                                id="fromDate"
                                innerRef={(el) => this.dtpFromDate = el}
                                value={this.state.fromDate}
                                caption={$.strings.inOutTotalReport.fromDate}
                                onChange={this.handleUserInput}
                                readOnlyInput={true}
                                readOnly={true}
                            />
                        </div>
                        <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12">
                            <Calendar
                                id="toDate"
                                innerRef={(el) => this.dtpToDate = el}
                                value={this.state.toDate}
                                caption={$.strings.inOutTotalReport.toDate}
                                onChange={this.handleUserInput}
                                readOnlyInput={true}
                                readOnly={true}
                            />
                        </div>

                    </div>


                    <div className="p-grid">
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="observeTheGracePeriod" caption={$.strings.salariesPerHours.observeTheGracePeriod}
                                onChange={e => this.setState({ observeTheGracePeriod: e.checked })} checked={this.state.observeTheGracePeriod} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="gracePeriodDeduction" caption={$.strings.salariesPerHours.gracePeriodDeduction}
                                onChange={e => this.setState({ gracePeriodDeduction: e.checked })} checked={this.state.gracePeriodDeduction} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="appeareTotalHours" caption={$.strings.salariesPerHours.appeareTotalHours}
                                onChange={e => this.setState({ appeareTotalHours: e.checked })} checked={this.state.appeareTotalHours} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="addVacationToTotalHours" caption={$.strings.salariesPerHours.addVacationToTotalHours}
                                onChange={e => this.setState({ addVacationToTotalHours: e.checked })} checked={this.state.addVacationToTotalHours} />
                    </div>
                    </div>

                    <div className="p-grid">
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="addVacationDays" caption={$.strings.salariesPerHours.addVacationDays}
                                onChange={e => this.setState({ addVacationDays: e.checked })} checked={this.state.addVacationDays} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="workingHoursOfTheShift" caption={$.strings.salariesPerHours.workingHoursOfTheShift}
                                onChange={e => this.setState({ workingHoursOfTheShift: e.checked })} checked={this.state.workingHoursOfTheShift} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="deductionOfRestPeriod" caption={$.strings.salariesPerHours.deductionOfRestPeriod}
                                onChange={e => this.setState({ deductionOfRestPeriod: e.checked })} checked={this.state.deductionOfRestPeriod} />
                    </div>
                    <div className="p-col-12 p-xl-3 p-lg-6 p-md-6 p-sm-12" style={{ alignSelf: 'flex-end' }}>
                            <Checkbox id="employeesWorkingWithoutFixedPeriod" caption={$.strings.salariesPerHours.employeesWorkingWithoutFixedPeriod}
                                onChange={e => this.setState({ employeesWorkingWithoutFixedPeriod: e.checked })} checked={this.state.employeesWorkingWithoutFixedPeriod} />
                    </div>
                    </div>

                    <div className="p-col-6 p-xl-2 p-lg-4 p-md-4 p-sm-12" style={{ alignSelf: 'flex-end', marginBottom: '5px' }}>
                       <Button label={$.strings.additionalFilters.title} className={this.state.dataObject.additionalFiltersObj ? 'p-button-warning' : ''}
                             onClick={e => this.dlgAdditionalFilters.show(this.state.dataObject.additionalFiltersObj)} />
                        <Button label="" icon="pi pi-filter-slash" visible={this.state.dataObject.additionalFiltersObj} tooltip={$.strings.additionalFilters.clearFilters}
                               onClick={e => this.setState({ dataObject:{...this.state.dataObject,additionalFiltersObj: undefined}  })}
                                    />
                                </div>
                </AccordionTab>
            </Accordion>
            <Card>
                <div className="p-grid">
                    <div className="p-col-12 p-xl-12 p-lg-12 p-md-12 p-sm-12">
                        <DataGrid
                            ref={e => this.gridData = e}
                            isReport={true}
                            theme="default-light"
                            idProperty="serial"
                            style={gridStyle}
                            scheme={this.getScheme()}
                            exportFileName={$.strings.salariesPerHours.title}
                            dataSource={this.state.data}
                        />
                    </div>
                </div>
            </Card>

            <ScrollTop />
        </div>
    }

    getFromCode = async () => {
        await this.dlgSearchFromEmployee.show();
    }
    showFromEmp = (obj) => {
        if (obj) {
            this.setState({ fromCode: obj.code })
        }
    }
    getToCode = async () => {
        await this.dlgSearchToEmployee.show();
    }
    showToEmp = (obj) => {
        if (obj) {
            this.setState({ toCode: obj.code })
        }
    }

    getShifts = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
        }
        let res = await http.getJsonAxios(http.actions.AttReports.urlGetShifts, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        return dataTemp;
    }
    getBranches = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            userId: localStorage.getItem("useridHR")
        }
        let res = await http.getJsonAxios(http.actions.AttReports.urlGetFillCmbBranches, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        return dataTemp
    }
    getSections = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            empCode: localStorage.getItem("useridHR")
        }
        let res = await http.getJsonAxios(http.actions.Sections.urlGetSections, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }
        return dataTemp
    }
    getDepartments = async () => {
        this.setState({ loading: true })
        let dataTemp = []
        let obj = {
            type: 8
        }
        let res = await http.getJsonAxios(http.actions.MultiFl.GetMultiFlByType, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.multiFlList;
            if (dataTemp) {
                dataTemp.splice(0, 0, { pos: -1, name: $.strings.all, ename: $.strings.all })
            }
        }
        return dataTemp
    }

    getData = async () => {
        if (!Util.compareCode(this.state.fromCode, this.state.toCode)) {
            Util.showErrorMsg(this.messages, $.strings.compareCodeError)
            return;
        }
        this.setState({ loading: true })
        let dataTemp = []


         let generalFillter = {};
        Util.fillAditionalsFilters(this.state.dataObject.additionalFiltersObj, generalFillter);
        let obj = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            user_id: localStorage.getItem("useridHR") + "",
            fromCode: this.state.fromCode && this.state.fromCode.length > 0 ? this.state.fromCode : '00000',
            toCode: this.state.toCode && this.state.toCode.length > 0 ? this.state.toCode : 'ZZZZZ',
            generalFillter:generalFillter,
            fromDep:this.state.fromDep,
            toDep:this.state.toDep,
            observeTheGracePeriod:true,
            gracePeriodDeduction :true,
            appeareTotalHours :true,
            addVacationToTotalHours:true,
            addVacationDays:true,
            workingHoursOfTheShift :true,
            deductionOfRestPeriod:true,
            employeesWorkingWithoutFixedPeriod :true,

        }
        let res = await http.postMultipartAxios(http.actions.Reports.urlGetSalaryForHours, obj, 0);
        if (res.status === 200) {
            dataTemp = res.data.list;
        }

        this.setState({ data: dataTemp, loading: false }, () => this.printFilters = this.state);
    }
    excelExport = () => {
        this.gridData.exportCSV();
    }

    print = async () => {

        if (!this.state.data || this.state.data.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }

        let obj = Print.getReportPrintObject($.strings.salariesPerHours.title, this.gridData, this.state.data);
        if (!obj || !obj.data || obj.data.columns.length <= 0) {
            Util.showErrorMsg(this.messages, $.strings.noRecordsToPrint)
            return;
        }
        let listOfFilters = [];
        if (this.printFilters) {
            let codeFilter = "", dateFilter = "";

            // Code Filter
            if (this.printFilters.fromCode) {
                codeFilter = $.strings.inOutTotalReport.fromCode + ": " + this.printFilters.fromCode;
            }
            if (this.printFilters.toCode) {
                if (codeFilter !== "")
                    codeFilter += " - ";
                codeFilter += $.strings.inOutTotalReport.toCode + ": " + this.printFilters.toCode;
            }
            if (codeFilter !== "") {
                listOfFilters.push(codeFilter);
            }

            if (this.printFilters.transType) {
                let name = this.printFilters.transType.name
                listOfFilters.push($.strings.inOutTotalReport.transType + ": " + name);
            }

            if (this.printFilters.fromMinute) {
                listOfFilters.push($.strings.salariesPerHours.fromMinute + ": " + this.printFilters.fromMinute);
            }
            if (this.printFilters.toMinute) {
                listOfFilters.push($.strings.salariesPerHours.toMinute + ": " + this.printFilters.toMinute);
            }

            // Date Filter
            if (this.printFilters.fromDate) {
                dateFilter = $.strings.inOutTotalReport.fromDate + ": " + Util.getDateFormat(this.printFilters.fromDate);
            }
            if (this.printFilters.toDate) {
                if (dateFilter !== "")
                    dateFilter += " - ";
                dateFilter = $.strings.inOutTotalReport.fromDate + ": ";
                dateFilter += Util.getDateFormat(this.printFilters.toDate);
            }
            if (dateFilter !== "")
                listOfFilters.push(dateFilter);


            if (Util.checkISHR()) {
                if (this.printFilters.shift) {
                    listOfFilters.push($.strings.salariesPerHours.shift + ": " + this.printFilters.shift.ShiftName);
                }
                if (this.printFilters.section) {
                    listOfFilters.push($.strings.inOutTotalReport.section + ": " + this.printFilters.section.Name);
                }
                if (this.printFilters.branch) {
                    listOfFilters.push($.strings.salariesPerHours.branch + ": " + this.printFilters.branch.Name);
                }
                if (this.printFilters.department) {
                    listOfFilters.push($.strings.salariesPerHours.department + ": " + this.printFilters.department.name);
                }

            }

            if (this.printFilters.observeRestPeriod)
                listOfFilters.push($.strings.salariesPerHours.observeRestPeriod + ": " + (this.printFilters.observeRestPeriod ? $.strings.yes : $.strings.no))
            if (this.printFilters.noInOnly)
                listOfFilters.push($.strings.salariesPerHours.showTotalInHours + ": " + (this.printFilters.showTotalInHours ? $.strings.yes : $.strings.no))

        }
        obj.headers = Print.getPrintingHeaderStrings(listOfFilters, obj.headers)

        Print.doPrintReport(obj);
    };
    onAdditionalFiltersSuccess = (obj) => {
        if (obj) {
            this.setState({ dataObject: { ...this.state.dataObject, additionalFiltersObj: obj } })
        }

    }
    getScheme = () => {
        return {
            name: "salariesPerHoursScheme_Table",
            filter: true,
            showFooter: true,
            sortable: true,
            allowGrouping: false,
            responsiveColumnIndex: 2,
            columns: [
                {
                    name: 'rowNumber', header: '##', width: 80, dataType: 'Number', aggregate: 'Cnt', columnWidth: '1'
                },
                {
                    name: 'code', header: $.strings.salariesPerHours.code, width: 120, columnWidth: '2'

                },
                {
                    name: 'name', header: $.strings.salariesPerHours.name, width: "*", columnWidth: '*'

                },
                {
                    name: 'sectionName', header: $.strings.salariesPerHours.section, width: 150, columnWidth: '*'

                },
                {
                    name: 'managmentName', header: $.strings.salariesPerHours.managment, width: 120,
                    visible: this.state.data.filter(e => e.PeriodOfDelay && e.PeriodOfDelay.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'branchName', header: $.strings.salariesPerHours.branch, width: 120,
                    visible: this.state.data.filter(e => e.AbsentDaysEarlyExit && e.AbsentDaysEarlyExit.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'jobName', header: $.strings.salariesPerHours.job, width: 120,
                    visible: this.state.data.filter(e => e.EarlyExit && e.EarlyExit.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'totInPeriod', header: $.strings.salariesPerHours.totInPeriod, width: 120,
                    visible: this.state.data.filter(e => e.PrivateExit && e.PrivateExit.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'overTime', header: $.strings.salariesPerHours.overTime, width: 120,
                    visible: this.state.data.filter(e => e.NumberOfTimesPrivateExit && e.NumberOfTimesPrivateExit.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'overTimeHoliday', header: $.strings.salariesPerHours.overTimeHoliday, width: 120,
                    visible: this.state.data.filter(e => e.M_Delay && e.M_Delay.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'overTimePercent', header: $.strings.salariesPerHours.overTimePercent, width:120,
                    visible: this.state.data.filter(e => e.Private_BeforeGoingOut && e.Private_BeforeGoingOut.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'vacation', header: $.strings.salariesPerHours.vacation, width: 120,
                    visible: this.state.data.filter(e => e.BeforeEntering && e.BeforeEntering.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'holiday', header: $.strings.salariesPerHours.holiday, width: 120,
                    visible: this.state.data.filter(e => e.AfterExit && e.AfterExit.length).length > 0, columnWidth: '2'

                },
                {
                    name: 'totHours', header: $.strings.salariesPerHours.totHours, width: 120,
                    visible: this.state.data.filter(e => e.ExtraDaysOff && e.ExtraDaysOff.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'salaryHour', header: $.strings.salariesPerHours.salaryHour, width: 120,
                    visible: this.state.data.filter(e => e.OutOfWorkingHours && e.OutOfWorkingHours.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'amount', header: $.strings.salariesPerHours.amount, width: 120,
                    visible: this.state.data.filter(e => e.WorkExit && e.WorkExit.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'requierd', header: $.strings.salariesPerHours.requierd, width:120,
                    visible: this.state.data.filter(e => e.M_WorkDuringWork && e.M_WorkDuringWork.length).length > 0, columnWidth: '2'
                },
                {
                    name: 'note', header: $.strings.salariesPerHours.note, width: 120,
                    visible: this.state.data.filter(e => e.M_KidneyWork && e.M_KidneyWork.length).length > 0, columnWidth: '2'
                }
            ]
        }
    }

}